"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'LegalTextBlock_1_0_0',
  paragraph: '',
  disclaimerLabel: '',
  disclaimerList: [],
  useAccordion: false
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;